/**
 * WP-V2-TW — smok-ambient: sylwetka przelatuje w tle co ~90 s (PLAN-V2 §2.5).
 * Brak interakcji; placeholder gdy brak dragon_day.png.
 */
import Phaser from 'phaser';
import { TOWN_WORLD_H, TOWN_WORLD_W } from './hotspots.js';

const INTERVAL_MS = 90_000;
const FLIGHT_MS = 14_000;

export class DragonAmbient {
  private timer: Phaser.Time.TimerEvent | null = null;
  private dragon: Phaser.GameObjects.Container | null = null;
  private flightCount = 0;

  constructor(private readonly scene: Phaser.Scene) {}

  start(): void {
    // pierwszy przelot po krótkim intro (~8 s), potem co 90 s
    this.scene.time.delayedCall(8_000, () => this.flyOnce());
    this.timer = this.scene.time.addEvent({
      delay: INTERVAL_MS,
      loop: true,
      callback: () => this.flyOnce(),
    });
  }

  /** Licznik przelotów (E2E / testy). */
  get flights(): number {
    return this.flightCount;
  }

  private flyOnce(): void {
    if (!this.scene.sys.isActive()) return;
    this.dragon?.destroy(true);

    const y = 90 + Math.random() * 80;
    const fromLeft = this.flightCount % 2 === 0;
    const startX = fromLeft ? -120 : TOWN_WORLD_W + 120;
    const endX = fromLeft ? TOWN_WORLD_W + 120 : -120;

    const parts: Phaser.GameObjects.GameObject[] = [];
    if (this.scene.textures.exists('dragon_day')) {
      const img = this.scene.add.image(0, 0, 'dragon_day').setDisplaySize(140, 80);
      parts.push(img);
    } else {
      // placeholder: pastelowy smok-sylwetka + ikona
      const body = this.scene.add
        .ellipse(0, 0, 120, 48, 0x7e57c2, 0.85)
        .setStrokeStyle(3, 0xffffff);
      const wing = this.scene.add.triangle(30, -18, 0, 40, 50, 40, 25, 0, 0xb39ddb, 0.9);
      const icon = this.scene.add
        .text(0, 0, '🐉', { fontSize: '36px' })
        .setOrigin(0.5);
      parts.push(body, wing, icon);
    }

    this.dragon = this.scene.add.container(startX, y, parts);
    this.dragon.setDepth(-50);
    this.dragon.setScale(fromLeft ? 1 : -1, 1);

    this.flightCount += 1;

    this.scene.tweens.add({
      targets: this.dragon,
      x: endX,
      y: y + 30,
      duration: FLIGHT_MS,
      ease: 'Sine.InOut',
      onUpdate: (tw) => {
        // lekka fala
        const t = tw.progress;
        if (this.dragon) {
          this.dragon.y = y + Math.sin(t * Math.PI * 2) * 24;
        }
      },
      onComplete: () => {
        this.dragon?.destroy(true);
        this.dragon = null;
      },
    });
  }

  destroy(): void {
    this.timer?.remove(false);
    this.timer = null;
    this.dragon?.destroy(true);
    this.dragon = null;
  }
}
